import { reactive, ref } from '@vue/composition-api'
import draftApi from '@/services/api/drafts'
import useFormAlert from '@/composables/useFormAlert'

export default function useDraftRules() {
  const rules = reactive({
    first_round_runs_per_person: '',
    total_runs_per_horse: '',
    exclude_first_round: [],
    exclude_total: []
  })
  // No-horse-required events never count toward these limits — pinned here so their
  // remove ("x") button is disabled in the UI (see FSearchSelect lockedIds) and, as a
  // backstop against vue-multiselect's backspace-removes-last-tag shortcut, so they
  // snap back if removed anyway. The backend enforces this too regardless of what's
  // submitted (see EloquentEventRepository::updateRuleExclusions).
  const pinnedEventIds = ref([])
  const submitting = ref(false)
  const alert = useFormAlert()

  function withPinned(ids) {
    return [...new Set([...ids, ...pinnedEventIds.value])]
  }

  function initRules(draft, events) {
    const s = draft.settings != null ? draft.settings : {}
    rules.first_round_runs_per_person = s.first_round_runs_per_person != null ? s.first_round_runs_per_person : ''
    rules.total_runs_per_horse = s.total_runs_per_horse != null ? s.total_runs_per_horse : ''
    pinnedEventIds.value = events.filter(e => e.requires_horse === false).map(e => e.id)
    rules.exclude_first_round = withPinned(events.filter(e => e.exclude_first_round_runs_per_person).map(e => e.id))
    rules.exclude_total = withPinned(events.filter(e => e.exclude_total_runs_per_horse).map(e => e.id))
  }

  function setExcludeFirstRound(ids) {
    rules.exclude_first_round = withPinned(ids)
  }

  function setExcludeTotal(ids) {
    rules.exclude_total = withPinned(ids)
  }

  async function saveRules(draftId) {
    submitting.value = true
    alert.clear()
    try {
      const payload = {
        first_round_runs_per_person: rules.first_round_runs_per_person !== '' ? rules.first_round_runs_per_person : null,
        total_runs_per_horse: rules.total_runs_per_horse !== '' ? rules.total_runs_per_horse : null,
        exclude_first_round_runs_per_person: rules.exclude_first_round,
        exclude_total_runs_per_horse: rules.exclude_total
      }
      const res = await draftApi.updateRules(draftId, payload)
      alert.showSuccess(res.data != null && res.data.message != null ? res.data.message : 'Draft rules have been saved.')
    } catch (err) {
      const data = err.response != null ? err.response.data : null
      const msg = data != null && data.message != null
        ? data.message
        : 'A server error occurred. Please try again later.'
      alert.showError(msg)
    } finally {
      submitting.value = false
    }
  }

  return { rules, submitting, alert, pinnedEventIds, initRules, saveRules, setExcludeFirstRound, setExcludeTotal }
}



// WEBPACK FOOTER //
// ./src/composables/drafts/useDraftRules.js